import { IconButton, List, ListItem, ListItemIcon, makeStyles, Popover, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import GetAppIcon from '@material-ui/icons/GetApp';
import MoreIcon from '@material-ui/icons/MoreVert';
import React, { useCallback, useContext, useState } from 'react';

import { HSTableContext } from 'Common/Table/HSTable/hs-table.context';
import Toolbar from 'Common/Toolbar';

import { exportCommitteeMeetingsList } from '../../../../api/hs/committee/committee-meetings';
import { CommitteeMeetingsContext } from '../../committee-meetings.context';
import CommitteeMeetingForm from '../Form';
import Filters from './Filters';
import VisibleColumnMenu from './VisibleColumnMenu';

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
}));

export default function ToolbarPPEDefinition() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
  const openPopover = useCallback(({ target }) => setAnchorEl(target as HTMLElement), []);
  const closePopover = useCallback(() => setAnchorEl(null), []);
  const { setNewDialogOpened, newDialogOpened, setSelectedData } = useContext(CommitteeMeetingsContext);
  const { data, refresh, extraArgs } = useContext(HSTableContext);

  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await refresh();
      }
      setNewDialogOpened(false);
      setSelectedData(null);
    },
    [setNewDialogOpened, setSelectedData, refresh]
  );

  const newPpeDefinition = useCallback(() => {
    closePopover();
    setNewDialogOpened(true);
  }, [setNewDialogOpened, closePopover]);

  const exportFile = useCallback(async () => {
    await exportCommitteeMeetingsList(extraArgs.filters);

    closePopover();
  }, [closePopover, extraArgs]);

  return (
    <Toolbar color="secondary">
      <Typography variant="h6" color="inherit">
        Toplantı Listesi ({data?.length})
      </Typography>
      <span className={classes.grow} />
      <div className={classes.sectionDesktop}>
        <IconButton color="inherit" onClick={openPopover}>
          <MoreIcon />
        </IconButton>
        <Popover anchorEl={anchorEl} anchorOrigin={{ vertical: 35, horizontal: -175 }} keepMounted open={!!anchorEl} onClose={closePopover}>
          <List>
            <ListItem onClick={newPpeDefinition} className="cursor-pointer">
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">Yeni ISG Kurul Toplantısı</Typography>
            </ListItem>
            <ListItem onClick={exportFile} className="cursor-pointer">
              <ListItemIcon>
                <GetAppIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">Excel'e Aktar</Typography>
            </ListItem>
          </List>
        </Popover>
      </div>
      <CommitteeMeetingForm open={newDialogOpened} onClose={closeDialog} data={null} />
      <VisibleColumnMenu />
      <Filters />
    </Toolbar>
  );
}
